import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'David Mudry',
    description: 'Web developer in Fort Worth, TX. I design and build websites for local businesses, launched fast or custom-built to grow. I handle the design, the build and every detail in between.',
    url: getOrigin(),
    links: {
        linkedin: 'https://www.linkedin.com/in/david-mudry-92626013b'
    }
}
